import { TNextStep } from '../../../types/form';
import { IStepsHistoryItem } from '../types/internal';

export const mapNextStepToHistoryItem = (step: TNextStep): IStepsHistoryItem => ({
  stepCode: step.nextStepCode,
  stepArgs: step.nextStepArgs,
});
